import { render, staticRenderFns } from "./SponsorshipSpotlight.vue?vue&type=template&id=6e194186&scoped=true&"
import script from "./SponsorshipSpotlight.vue?vue&type=script&lang=js&"
export * from "./SponsorshipSpotlight.vue?vue&type=script&lang=js&"
import style0 from "./SponsorshipSpotlight.vue?vue&type=style&index=0&id=6e194186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e194186",
  null
  
)

export default component.exports